import { el } from "@dhx/ts-common/dom";
import { NavigationBarEvents } from "../types";

function onBlur(events, id) {
	events.fire(NavigationBarEvents.inputBlur, [id]);
}

function onFocus(events, id) {
	events.fire(NavigationBarEvents.inputFocus, [id]);
}

export function input(item, events, widgetName: string) {
	return el(".dhx_form-group.dhx_form-group--no-message-holder.dhx_form-group--label_sr" + `.dhx_${widgetName}__input`, {
		style: {
			width: item.width ? item.width : "200px"
		},
	}, [
		el("label.dhx_label", {for: item.id}, item.label),
		el(".dhx_input__wrapper", [
			el("input.dhx_input", {
				placeholder: item.placeholder,
				class: item.icon ? "dhx_input--icon-padding" : "",
				value: item.value,
				onblur: [onBlur, events, item.id],
				onfocus: [onFocus, events, item.id],
				dhx_id: item.id,
				_hooks: {
					didInsert(node) {
						if (events) {
							events.fire(NavigationBarEvents.inputCreated, [item.id, node.el]);
						}
					}
				},
				_key: item.id
			}),
			item.icon ? el(".dhx_input__icon", {
				class: item.icon
			}) : null,
		])
	]);
}